import { CellContext, type RowData } from 'src/lib/tanstack-react-table';
import { Chip } from 'src/components/atoms';
import { StyledLabel } from './common';

export const RoleCell = <TType extends RowData, TValue>({ getValue }: CellContext<TType, TValue>) => {
  const cellValue = getValue<Array<{ user_role: string }>>() || [];

  const role = (
    cellValue.map((_role) => _role.user_role.toLowerCase()).includes('privileged') ? 'privileged' : 'reader'
  ).toUpperCase();

  const color = role === 'PRIVILEGED' ? '#FA7E61' : '#09b709';

  return (
    <StyledLabel>
      <Chip label={role} $color={color} />
    </StyledLabel>
  );
};
